export default __webpack_public_path__ + "vladp.5a678a60.jpg";